import { useState } from "react";
import { Navigate, NavLink, Link } from "react-router-dom";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { app } from "../../../../firebase.config";
import GetData from "../../../../Api/GetData";
import PostData from '../../../../Api/PostData'
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
// import signinLogo1Img from '../../../../Assets/Img/signin/signinlogo1.png'
// import signinLogo2Img from '../../../../Assets/Img/signin/signinlogo2.png'
// import signinLogo3Img from '../../../../Assets/Img/signin/signinlogo3.png'
import axios from "axios";

import './login.css'
import analytics from '../../../../firebase.config';

import { getAnalytics, logEvent } from "firebase/analytics";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
const Login = () => {
  const history = useNavigate();
  const initialState = {
    email: "",
    password: "",
    error: "",
    login: localStorage.getItem("AOFLoggedIn"),
    sendingReq: false,
  };

  const auth = getAuth();
  const [formData, setformData] = useState(initialState);
  const { email, password, error, login, sendingReq } = formData;
  const [show, setShow] = useState(false)
  function handleShow() {
    setShow(!show)
    console.log(show)
  }



  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    if (type === "checkbox") {
      setformData({
        ...formData,
        [name]: checked,
      });
    } else if (type === "file") {
      if (files[0].size / 1024 < 6145) {
        setformData({
          ...formData,
          [name]: files,
        });
      } else {
        alert("File size must be below 5 MB");
      }
    } else if (
      name === "firstName" ||
      name === "lastName" ||
      name === "RelativeName" ||
      name === "sourceofincome"
    ) {
      setformData({
        ...formData,
        [name]: value.replace(/[^a-zA-Z\s]/gi, ""),
      });
    } else if (
      name === "street" ||
      name === "Apt" ||
      name === "street" ||
      name === "MailApt" ||
      name === "EmployStreet" ||
      name === "EmployApt"
    ) {
      setformData({
        ...formData,
        [name]: value.replace(/[^a-zA-Z0-9\-#\s]/gi, ""),
      });
    } else if (name === "CNIC" || name === "RelativeCNIC") {
      setformData({
        ...formData,
        [name]: value.replace(/[^0-9]/gi, ""),
      });
    } else if (name === "email" || name === "password") {
      setformData({
        ...formData,
        [name]: value,
      });
    } else {
      setformData({
        ...formData,
        [name]: value.replace(/[^0-9a-zA-Z\s]/gi, ""),
      });
    }
  };

  const handleSubmit = (e, email, password) => {
    e?.preventDefault();
    setformData({
      ...formData,
      sendingReq: true,
    });

    axios
      .post("account-details/authenticate", {
        email: email,
        password: password,

      })
      .then((value) => {
        console.log('va;ue iiii=======', value)

        if (value?.data?.token) {
          let jwtTokenObj = jwt_decode(value?.data?.token);
          setformData({
            ...formData,
            sendingReq: true,
          });
          // Signed in


          logEvent(analytics, 'successfull_login');
          localStorage.setItem("AOFLoggedIn", "true");
          localStorage.setItem("user", JSON.stringify(jwtTokenObj));


          localStorage.setItem("token", value?.data?.token);
          axios.defaults.headers = {
            "x-auth-token": value?.data?.token,
            "Content-Type": "application/json",
          };

          // this is called for checking the status of otp either Otp generated or not 
          const response = GetData.getSaveAndExistData();
          response.then((value) => {
            setformData({
              sendingReq: false,
            });
            if (value?.data?.Stamp == 'OTP-Awaiting' || value?.data?.Stamp == 'Otp-Awaiting') {
              logEvent(analytics, 'dashb_update_state_to_awaiting_OTP');

              history("/Otp");

            }
            else if (value?.data?.Stamp == 'OTP-Verified' || value?.data?.Stamp == 'Record-Submitted') {
              logEvent(analytics, 'dashb_update_to_OTP_verf_and_final_setup');
              history("/successotp");
            }
            else {
              history("/Dashboard");
            }
          })


        }
        else {
          setformData({
            ...formData,
            sendingReq: false,
          });


          const errorMessage = value?.data?.message

          console.log(errorMessage?.toString()?.includes('Email not verified'), 'error respons e0 =======', errorMessage)

          if (errorMessage.toString().includes('Email not verified') == true) {
            var uIDSplit = errorMessage?.split(',');
            localStorage.setItem("uid", JSON?.stringify(uIDSplit[1]));
            localStorage.setItem("email", JSON?.stringify(email));
            if (uIDSplit[0] == 'Email not verified' || uIDSplit[0] == 'UnauthorizedError: Email not verified') {
              history("/Verification");
            }

          }

          else {
            console.log('============errorMessage ', errorMessage.code)
            switch (errorMessage?.code) {
              case "auth/user-not-found":
                setformData({
                  ...formData,
                  error: "The email or password is incorrect",
                });
                break;
              case "auth/wrong-password":
                setformData({
                  ...formData,
                  error: "The email or password is incorrect",
                });
                break;

              case "auth/wrong-password":
                setformData({
                  ...formData,
                  error: "The email or password is incorrect",
                });
                break;
              case "auth/user-not-found":
                setformData({
                  ...formData,
                  error: "The email or password is incorrect",
                });
                break;
              case "auth/too-many-requests":
                setformData({
                  ...formData,
                  error: "Too many Requests",
                });
                break;


              default:
                setformData({
                  ...formData,
                  error: "An unknown error has occurred",
                });

            }



          }






        }




      })
      .catch(function (error) {
        console.log('error ==?', error)
      })



  };

  return (
    <>
      {login ? (
        <Navigate to="/Dashboard" />
      ) : (
        <>

          <div className="mx-auto h-100">

            <div className="card card0 border-0 h-100">
              <div className="d-flex justify-content-center h-100">
                <div className="row w-100">
                  <div className="col-lg-6 bg-left-color d-none d-lg-block" >

                    <div className="middle">

                      <div id="demo" className="carousel slide" data-ride="carousel">


                        <ul className="carousel-indicators">
                          <li data-target="#demo" data-slide-to="0" className="active"></li>
                          {/* <li data-target="#demo" data-slide-to="1"></li>
                          <li data-target="#demo" data-slide-to="2"></li> */}
                        </ul>


                        <div className="carousel-inner">
                          {/* <div className="carousel-item active">

                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/signinlogo1.png" alt="Los Angeles" />
                          </div>
                          <div className="carousel-item">

                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/signinlogo2.png" alt="Los Angeles" />

                          </div> */}
                          <div className="carousel-item active">

                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/signinlogo3.png" alt="Los Angeles" />

                          </div>
                        </div>


                        {/* <a className="carousel-control-prev" href="#demo" data-slide="prev">
  <span className="carousel-control-prev-icon"></span>
</a>
<a className="carousel-control-next" href="#demo" data-slide="next">
  <span className="carousel-control-next-icon"></span>
</a> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 col-lg-6 bg-gray justify-content-lg-start mx-auto mx-lg-0 middle">
                    <div className="card border-0 px-md-4  mx-auto mx-lg-0 w-100">


                      <div className="d-flex justify-content-center justify-content-lg-start newregisterForm">
                        <div className="d-flex justify-content-between align-items-center logo">
                          <div className="text-decoration-none">
                            <Logo />
                          </div>
                          <div className=''>
                            <button
                              className="dashboard-beta "
                            >
                              Beta Version
                            </button>
                          </div>

                        </div>

                      </div>

                      <>

                        <div className="">

                          <div className=" edge  newloginForm  mb-3">
                            <p className="Bold REM1 text-center text-lg-start ">Sign in to your account</p>
                            {/* <p className=" t-grey-200 ">
                             Sign in to get your portfolio updates, make transactions and get
                            on-demand customer support.{" "}
                         </p> */}
                            <form onSubmit={(e) => handleSubmit(e, email, password)} className="signIn-form">
                              <input
                                type="email"
                                name="email"
                                className="form-control mb-3"
                                placeholder="Email"
                                value={email}
                                onChange={handleChange}
                                id="email"
                                required
                                maxLength="50"
                              />
                              {/* <input
                  type="password"
                  name="password"
                  className="form-control mb-3"
                  placeholder="Password"
                  value={password}
                  onChange={handleChange}
                  id="password"
                  minLength="8"
                  maxLength="12"
                  required
                />  */}
                              <input
                                type={show === false ? "password" : "text"}
                                name="password"
                                className="form-control mb-3"
                                placeholder="Password"
                                value={password}
                                onChange={handleChange}
                                id="password"
                                minLength="8"
                                maxLength="100"
                                required
                              />
                              {password?.length > -1 ? <span>  {show === true ? <span><EyeFilled onClick={handleShow} className='eyeiconsignin' /></span> : <span><EyeInvisibleFilled onClick={handleShow} className='eyeiconsignin' /></span>}
                              </span> : ""}


                              <NavLink className="text-decoration-none" to="/ForgetPassword">

                                <span className="  t-pink mb-5 fs14 fw-500 ">

                                  Forgot password?

                                </span>


                              </NavLink>

                              <button
                                className="btn-filled fs16 px-3 py-3 w-100 mt"
                                type="submit"
                              >
                                {sendingReq ? (
                                  // <div className="spinner-border text-light" role="status">
                                  //   <span className="visually-hidden">Loading...</span>
                                  // </div>
                                  <div className="whitespinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  <>Sign In</>
                                )}
                              </button>
                              <p className="text-danger fs12  mt16">{error}</p>
                            </form>
                            <p className="text-center text-lg-start t-grey-200 fs14">
                              Don't have an account? Register
                              <NavLink className="text-decoration-none" to="/Register">
                                <span className="t-pink mx-1 "><b>here.</b></span>
                              </NavLink>

                            </p>
                          </div>




                        </div>

                      </>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Login;


const Logo = () => (
  <svg width="170" height="48" style={{ marginLeft: '-17px' }} viewBox="0 0 144 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5.92548H38.5155V44.441L19.2578 24.7018L0 5.92548Z" fill="url(#paint0_linear_1992_933)" />
    <path d="M0 12.5093H31.9317V44.441L15.9658 28.076L0 12.5093Z" fill="url(#paint1_linear_1992_933)" />
    <path d="M56.4401 5.90989H51.4814V23.3904H56.4401V14.7391C56.4401 12.6386 56.4755 9.32766 59.4153 9.32766C62.2135 9.32766 62.1072 12.0334 62.1072 14.1339V23.3904H67.0659V12.7098C67.0659 8.65123 65.7684 5.90989 61.093 5.90989C59.322 5.90989 57.3073 6.25466 56.5109 7.51197H56.4401V5.90989Z" fill="#230B59" />
    <path d="M84.5587 15.4512V14.8459C84.5587 9.57688 82.0085 5.90989 76.3059 5.90989C70.6742 5.90989 67.8761 9.50567 67.8761 14.8103C67.8761 20.115 71.2055 23.3904 76.5893 23.3904C80.2375 23.3904 83.3135 21.7267 84.4524 17.7653H79.8833C79.2103 19.1538 78.2186 19.9162 76.5893 19.9162C74.0037 19.9162 73.1182 17.6585 73.1182 15.4512H84.5587ZM73.2599 12.3538C73.5078 10.5381 74.6058 9.21739 76.5893 9.21739C78.5019 9.21739 79.6354 10.5737 79.8833 12.3538H73.2599Z" fill="#230B59" />
    <path d="M90.4979 13.8847L83.0598 23.3904H89.2228L93.2252 17.3025L97.688 23.3904H103.78L96.4483 13.8847L93.7567 10.1109L90.5333 5.90989H84.512L90.4979 13.8847Z" fill="#230B59" />
    <path d="M109.786 10.1109H112.832V5.90989H109.786V0H104.827V23.3904H109.786V10.1109Z" fill="#230B59" />
    <path d="M66.1955 28.146C64.0557 26.6646 61.816 26.3354 60.4346 26.3354C55.1926 26.3354 51.3818 29.7876 51.3818 34.9855C51.3818 40.0054 54.9696 43.7826 60.1054 43.7826C61.6285 43.7826 64.1224 43.2888 65.8663 41.8075C65.8663 41.8075 65.6063 41.6167 65.0433 40.4907C64.5495 39.5031 64.4516 38.3677 64.4516 38.3677C63.5661 39.3645 62.2744 39.8323 60.9284 39.8323C58.0949 39.8323 56.4114 37.7624 56.4114 35.0211C56.4114 32.4578 57.6365 30.0369 60.4346 30.0369C61.9577 30.0369 63.3974 30.2857 64.3849 31.2733C64.3849 31.2733 64.6938 30.2857 65.2272 29.4627C65.7607 28.6398 66.1955 28.146 66.1955 28.146Z" fill="#230B59" />
    <path d="M83.5406 26.2251H78.6527V27.7193C77.4485 26.2952 75.554 26.0816 73.7476 26.0816C68.7535 26.0816 65.8663 30.1046 65.8663 34.7328C65.8663 39.4679 68.6999 43.6723 73.8003 43.6723C75.6066 43.6723 77.5193 43.3485 78.5819 41.96H78.6527V43.6723H83.5406V26.2251ZM75.0045 39.7171C72.4543 39.7171 70.8959 37.1538 70.8959 34.804C70.8959 32.4543 72.4543 29.9266 75.0045 29.9266C77.5547 29.9266 79.1486 32.4543 79.1486 34.804C79.1486 37.1538 77.5547 39.7171 75.0045 39.7171Z" fill="#230B59" />
    <path d="M90.3902 26.3354H85.4315V53H90.3902V42.0347H90.4611C91.5433 42.9596 93.3935 43.7826 95.1644 43.7826C100.3 43.7826 103.141 39.6137 103.141 34.8431C103.141 30.2505 100.252 26.3354 95.329 26.3354C93.4872 26.3354 91.5433 26.8292 90.3902 27.7939V26.3354ZM94.003 39.8273C91.4528 39.8273 89.8944 37.264 89.8944 34.9143C89.8944 32.5646 91.4528 30.0369 94.003 30.0369C96.5532 30.0369 98.1117 32.5646 98.1117 34.9143C98.1117 37.264 96.5532 39.8273 94.003 39.8273Z" fill="#230B59" />
    <path d="M109.786 26.3354H104.827V43.6723H109.786V26.3354Z" fill="#230B59" />
    <path d="M116.41 30.3929V26.3354V23.3904H111.451V43.6723H116.41V30.3929Z" fill="#230B59" />
    <path d="M137.384 26.1919H132.496V27.8296C131.292 26.4055 129.561 26.1919 127.755 26.1919C122.76 26.1919 119.71 30.2149 119.71 34.8431C119.71 39.5781 122.654 43.6723 127.755 43.6723C129.561 43.6723 131.363 43.4587 132.425 42.0703H132.496V43.6723H137.384V26.1919ZM128.848 39.8273C126.298 39.8273 124.739 37.264 124.739 34.9143C124.739 32.5646 126.298 30.0369 128.848 30.0369C131.398 30.0369 132.992 32.5646 132.992 34.9143C132.992 37.264 131.398 39.8273 128.848 39.8273Z" fill="#230B59" />
    <path d="M143.885 13.482H138.926V43.6723H143.885V13.482Z" fill="#230B59" />
    <path d="M102.735 5.92548H97.5325L94.8347 9.49957L97.3398 12.5093L102.735 5.92548Z" fill="url(#paint2_linear_1992_933)" />
    <path d="M117.55 26.3354H122.817C122.817 26.3354 121.171 27.323 120.348 28.4751C119.525 29.6273 119.36 30.2857 119.36 30.2857H117.55V26.3354Z" fill="url(#paint3_linear_1992_933)" />
    <defs>
      <linearGradient id="paint0_linear_1992_933" x1="-1.64416" y1="-13.0565" x2="36.2682" y2="41.6844" gradientUnits="userSpaceOnUse">
        <stop stopColor="#230B59" />
        <stop offset="1" stopColor="#E92A5E" />
      </linearGradient>
      <linearGradient id="paint1_linear_1992_933" x1="21.2329" y1="44.441" x2="21.2329" y2="12.5093" gradientUnits="userSpaceOnUse">
        <stop stopColor="#82297D" />
        <stop offset="1" stopColor="#E12C61" />
      </linearGradient>
      <linearGradient id="paint2_linear_1992_933" x1="98.785" y1="5.92548" x2="98.785" y2="12.5093" gradientUnits="userSpaceOnUse">
        <stop stopColor="#82297D" />
        <stop offset="1" stopColor="#E12C61" />
      </linearGradient>
      <linearGradient id="paint3_linear_1992_933" x1="120.183" y1="26.3354" x2="120.183" y2="30.2857" gradientUnits="userSpaceOnUse">
        <stop stopColor="#82297D" />
        <stop offset="1" stopColor="#E12C61" />
      </linearGradient>
    </defs>
  </svg>

)

































